var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AsiToolbar',{attrs:{"icon":_vm.icons.orders,"title":_vm.$t('uiTerms.yourNextOrders')}}),_c('PlanningEntryList',{attrs:{"hide-toolbar":true,"planning-entry-filter-model":_vm.filter}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }